export default __webpack_public_path__ + "static/media/icon-soja.33f845c2.svg";